<div class="position-relative d-flex justify-content-center min-wpx-40">
  <div class="bg-{{ value }} hf-xs w-100 rounded-2 "></div>
  <span
    class="position-absolute translate-middle-x top-3 fs-2xs start-50 text-center text-nowrap"
    >{{ description }}</span
  >
</div>
